/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { TrendValue, TrendValue$inboundSchema } from "./trendvalue.js";

/**
 * Data availability status for this source.
 */
export const PointAggregationResultStatus = {
  Data: "data",
  NoData: "no_data",
} as const;
/**
 * Data availability status for this source.
 */
export type PointAggregationResultStatus = OpenEnum<
  typeof PointAggregationResultStatus
>;

/**
 * A set of results for a point aggregation.
 */
export type PointAggregationResult = {
  /**
   * The values.
   */
  results: { [k: string]: Array<TrendValue> };
  /**
   * Data availability status for this source.
   */
  status: PointAggregationResultStatus;
};

/** @internal */
export const PointAggregationResultStatus$inboundSchema: z.ZodType<
  PointAggregationResultStatus,
  z.ZodTypeDef,
  unknown
> = openEnums.inboundSchema(PointAggregationResultStatus);

/** @internal */
export const PointAggregationResult$inboundSchema: z.ZodType<
  PointAggregationResult,
  z.ZodTypeDef,
  unknown
> = z.object({
  results: z.record(z.array(TrendValue$inboundSchema)),
  status: PointAggregationResultStatus$inboundSchema.default("data"),
});

export function pointAggregationResultFromJSON(
  jsonString: string,
): SafeParseResult<PointAggregationResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PointAggregationResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PointAggregationResult' from JSON`,
  );
}
